module.exports = __webpack_public_path__ + "static/media/download-icon.2224604c.svg";